import Styles from './ConnectButton.module.scss'
import { Button } from 'blaze-ui/Button'
import {
  providerFromChannelType,
  useArticlePostPreviewContext,
} from 'components/ArticlePostPreview/ArticlePostPreviewContext'
import { SocialChannelType, platformKeyByChannel } from 'common/ShareSheetV2/Screens/Default/Default'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { ConnectAccountDrawer } from 'components/PostStatusDropdown/ConnectAccountDrawer'
import { IntegrationsDrawer } from '../PostPreviewBody/IntegrationsDrawer/IntegrationsDrawer'
import { ArrowRefresh } from 'blaze-ui/icons'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { ButtonVariant } from 'blaze-ui/Button/Types'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

interface Props {
  margin?: string
  isDisabled?: boolean
  variant?: ButtonVariant
}

export const ConnectButton = observer(({ margin = '0 0 0 auto', isDisabled, variant = 'tertiary' }: Props) => {
  const {
    state: { integration, channel },
    almanacFile,
  } = useArticlePostPreviewContext()

  const { data } = useExternalIntegrations()
  const integrations = data?.external_integrations
  const isPostPreviewV2 = useFlipperFlag('post_preview_v2')

  const provider = integration?.provider || providerFromChannelType[channel as ChannelType]
  const drawersStore = useRootStore().drawersStore
  const hasIntegrationForChannel = integrations?.some(
    (integration) => integration.provider === platformKeyByChannel[channel as SocialChannelType],
  )

  const style = { margin }

  if (isPostPreviewV2) {
    return null
  }

  if (hasIntegrationForChannel)
    return (
      <div className={Styles.connectionContainer} style={style}>
        <Button
          variant={variant}
          size="sm"
          frontIcon={ArrowRefresh}
          isDisabled={isDisabled}
          onPress={() =>
            drawersStore.openDrawer(IntegrationsDrawer, {
              integration: integration,
              provider: provider,
              almanacFile: almanacFile,
            })
          }
        >
          Switch
        </Button>
      </div>
    )

  return (
    <div className={Styles.connectionContainer} style={style}>
      <Button
        variant={variant}
        size="sm"
        isDisabled={isDisabled}
        onPress={() => {
          drawersStore.openDrawer(ConnectAccountDrawer, { channel: channel as SocialChannelType })
        }}
      >
        <div className={Styles.connectButton}>
          <ChannelIcon channel={channel} size={20} />
          <span>Connect</span>
        </div>
      </Button>
    </div>
  )
})
